import {athubAxios} from "../../../util/athub-axios"

const permissionGroup = {
    page: page,
    add: add,
    update: update,
    remove: remove,
    findById: findById,
    permissionGroupOptions: permissionGroupOptions
};

export default permissionGroup;

import {ORGANIZATION_SERVER} from '@/api/server'

/**
 * 条件查询模块列表分页信息
 * @param params
 * @returns {Promise<unknown>}
 */
export function page(params) {
    return new Promise(((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/permissionGroup/page`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }))
}

/**
 * 获取所有模块options
 */
export function permissionGroupOptions(){
    return new Promise(((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/permissionGroup/options`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            ).catch(err => {
            reject(err);
        })
    }));
}

/**
 * 添加模块信息
 * @param params
 * @returns {Promise<unknown>}
 */
export function add(params) {
    return new Promise(((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/permissionGroup`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            ).catch(err => {
            reject(err);
            })
    }));
}

/**
 * 修改模块信息
 * @param id 模块ID
 * @param params
 * @returns {Promise<unknown>}
 */
export function update(id, params) {
    return new Promise(((resolve, reject) => {
        athubAxios.put(`${ORGANIZATION_SERVER}/permissionGroup/${id}`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }));
}

/**
 * 删除模块信息
 * @param id 模块ID
 * @returns {Promise<unknown>}
 */
export function remove(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.delete(`${ORGANIZATION_SERVER}/permissionGroup/${id}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }));
}

/**
 * 根据模块ID查询模块详情
 * @param id
 * @returns {Promise<unknown>}
 */
export function findById(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/permissionGroup/${id}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }));
}